module.exports = __webpack_public_path__ + "static/media/Ficha.caf76e1f.docx";